// extracted by mini-css-extract-plugin
export default {"configurationContainer":"Configuration_configurationContainer__W2MCt"};